import { ArchiveLalSegmentDialogContent } from '@openx/components-segment/lib/components/ArchiveLalSegmentsDialog/ArchiveLalSegmentDialogContent.tsx';
import { useLalSegmentsOperations } from '@openx/components-segment/lib/hooks/useLalSegmentsOperations.tsx';
import { isLalSegmentInProcessing } from '@openx/components-segment/lib/utils/isLalSegmentInProcessing.ts';
import { type ListLalSegment, lalSegmentRowActionType } from '@openx/types/segments.ts';
import { sortMenuButtonItems } from '@openx/utils/lib/tableHelpers.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const useLalSegmentRowActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { callLalSegmentAction } = useLalSegmentsOperations();

  const lalSegmentRowActions = useMemo(
    () =>
      sortMenuButtonItems<ListLalSegment>({
        DETAILS: {
          'data-test': 'details',
          label: t('Details'),
          onClick: lalSegment => {
            navigate(`/segments/lookalike/${lalSegment.id}`);
          },
        },
        DELETE: {
          color: 'error',
          danger: true,
          'data-test': 'archive',
          label: t('Archive'),
          disabled: lalSegment => isLalSegmentInProcessing(lalSegment),
          onClick: lalSegment => {
            callLalSegmentAction({
              action: lalSegmentRowActionType.DELETE,
              content: <ArchiveLalSegmentDialogContent data={[lalSegment]} />,
              segments: [lalSegment],
            });
          },
        },
        EDIT: {
          'data-test': 'edit',
          label: t('Edit'),
          onClick: lalSegment => {
            navigate(`/segments/lookalike/${lalSegment.id}/edit`);
          },
          disabled: lalSegment => isLalSegmentInProcessing(lalSegment),
        },
        USE_AS_TEMPLATE: {
          'data-test': 'use-as-template',
          label: t('Use As Template'),
          onClick: lalSegment => {
            navigate('/segments/lookalike/create', {
              state: {
                lalSegment,
                useAsTemplate: true,
              },
            });
          },
        },
      }),
    [t, navigate, callLalSegmentAction]
  );

  return lalSegmentRowActions;
};
